<template>
    <div class="company-law">
        <v-row class="mx-0">
            <v-col cols="12">
                <v-text-field v-model="company.address" label="Адрес (юридический)" color="teal" @change="companyChange"/>
            </v-col>
            <v-col cols="12" class="col-sm-6 col-md-3">
                <v-text-field v-model="company.bankAccount" label="Расчетный счет" color="teal" @change="companyChange"/>
            </v-col>
            <v-col cols="12" class="col-sm-6 col-md-3">
                <v-text-field v-model="company.bankFullName" label="Название банка" color="teal" @change="companyChange"/>
            </v-col>
            <v-col cols="12" class="col-sm-6 col-md-3">
                <v-text-field v-model="company.bankMfo" label="МФО банка" color="teal" @change="companyChange"/>
            </v-col>
            <v-col cols="12" class="col-sm-6 col-md-3">
                <v-text-field v-model="company.edprou" label="ЕДПРОУ" color="teal" @change="companyChange"/>
            </v-col>
        </v-row>
    </div>
</template>

<script>
    export default {
        name: "CompanyLaw",
        props:['companyData'],
        data() {
            return {
                company: {},
            }
        },
        computed: {

        },
        methods: {
            companyChange() {
                this.$emit('change', this.company);
            },

        },
        created() {
            this.company = Object.create(this.companyData);
        },
        watch: {
            companyData: {
                handler() {
                    this.company = Object.create(this.companyData);
                },
                deep: true
            },
        }
    }
</script>

<style scoped>

</style>